import { Box, IconButton, useTheme } from "@mui/material";
import { useContext, useState, useEffect } from "react";
// import { Link } from "@mui/material"
import { Link } from 'react-router-dom';
import { ColorModeContext, HideModeContext, tokens, useHideMode } from "../../theme";
import { SettingsBarContext } from "../../context/SettingsBarContext";
import InputBase from "@mui/material/InputBase";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import SearchIcon from "@mui/icons-material/Search"

const Topbar = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const colorMode = useContext(ColorModeContext);
    const hideMode = useContext(HideModeContext);
    const hideTheme = useHideMode();
    const { toggleSettingsBar } = useContext(SettingsBarContext);

    const handleClick = () => {
        toggleSettingsBar();
    }


    return (
        <Box display="flex" justifyContent="space-between" p={2}>

            {/* SEARCH BAR */}
            <Box
                display="flex"
                backgroundColor={colors.primary[400]}
                borderRadius="3px"

            >
                {/* <InputBase sx={{ ml: 2, flex: 1 }} placeholder="Search" />
                <IconButton type="button" sx={{ p: 1 }}>
                    <SearchIcon />
                </IconButton> */}
            </Box>
            {/* <Box display="flex"></Box> */}

            {/* ICONS */}
            <Box display="flex">
                <IconButton onClick={hideMode.toggleHideMode}>
                    {hideTheme.mode === "show" ? (
                        <VisibilityOffIcon />
                    ) : (
                        <VisibilityIcon />
                    )}
                </IconButton>


                <IconButton onClick={colorMode.toggleColorMode}>
                    {theme.palette.mode === "dark" ? (
                        <LightModeOutlinedIcon />
                    ) : (
                        <DarkModeOutlinedIcon />
                    )}
                </IconButton>


                <IconButton>
                    < NotificationsOutlinedIcon />
                </IconButton>

                <IconButton onClick={handleClick} >
                    < SettingsOutlinedIcon />
                </IconButton>

                < Link to="/accounts" >
                    <IconButton >
                        < PersonOutlinedIcon />
                    </IconButton>
                </Link>

            </Box>
        </Box >)
};

export default Topbar;